$(window).load(function() {
	$(document).ready(function() {

		function autoShopLook(view) {

			if (view.matches) {
				let pinned = $(".select-icon");

				$.each(pinned, function(key, val) {
					;
					let positionVal = $(val);
					let calcTop = positionVal.css('top')
					let calcLeft = positionVal.css('left');
					positionVal.css('top', `calc(${calcTop} - 5%)`);
					positionVal.css('left', `calc(${calcLeft} - 15%)`);
				})
			}
		}

		function moveGiftcard() {
			let header = $('.header-panel-bt .container .row .col-12.col-xl-3.wrapper-center.header-items');
			let moveGiftcard = $('.header-items.header-cart');
			let giftCardComponent = $('.header-panel-bt .container .row .col-12.col-xl-4.wrapper-left.header-items .append-mb .header-giftcards');
			let rightside = $('.header-panel-bt .container .row');

			rightside.children('div[style]').remove()

			//change wrapper
			header.removeClass('wrapper-center');
			header.addClass('wrapper');

			//change class column
			header.removeClass('col-xl-3');
			header.addClass('col-xl-2');

			// insert into column systems
			let column = $('<div class="col-12 col-xl-4 wrapper header-items"><div class="append-mb right-append" data-links-menu-mobile></div></div>');

			// wrapper giftcard
			let myWrapper = column.children().append(giftCardComponent).append(moveGiftcard);

			// insert to rightside
			rightside.append(column);
			$('.header-panel-bt .container .row .col-12.col-xl-4.wrapper.header-items .append-mb').css('width', '100%');
          	$('.header-panel-bt .container .row .col-12.col-xl-4.wrapper.header-items .append-mb').css({
              'justify-content': 'start',
              'padding-left': '40px',
          	});
			// 			$('.header-panel-bt .container .row .col-12.col-xl-4.wrapper.header-items .append-mb').css('padding', '0 60px');


			// delete giftcard yang ada di kiri
			giftCardComponent.remove();

			// setting height cart biar rata
			$('.header-items.header-cart a span svg').css('height', '28px');
		}

		//pindahin posisi language
		function moveLang() {
			setTimeout(function() {
				let switcherLang = $('.weglot-container.wg-default');
              	console.log(switcherLang);
				let switcherMove = $('.mb-area.header-bottom-left.horizontal-menu');
				let switcherLangCombo = switcherLang.find('form .tl-select');
				let switcherLangOptions = switcherLang.find('form .tl-options');
				let desktopPosition = $('.col-12.col-xl-4.wrapper.header-items .append-mb.right-append');
				if (window.matchMedia('(max-width: 768px)').matches) {
					switcherMove.append(switcherLang);
					switcherLang.find('aside').css({
						'position': 'static',
						'box-shadow': 'none',
						'display': 'flex',
						'border-radius': '3px',
                      	'width': '100%',
                        'margin-left': '10px',
                      'margin-top': '20px'
					});
				

					switcherLangCombo.css({
						'box-shadow': '0 0 10px #00000026',
						'margin-top': '5px',
						'border-radius': '3px',
					})
					switcherLangOptions.css({
						'min-width': '73.13px',
						'left': 'auto',
                      	'top': '103%',
                    })
				} else {
					desktopPosition.append(switcherLang);
                    switcherLang.find('aside').css({
                      "display" : "block",
                      "position": "static",
                      "margin-left": "40px",
                    });
				}
                switcherLang.find('aside ul').css({
                	"right": "auto",
                    "max-height": "none",
                    "min-width": "auto",
                    "width": "104px",
                    "margin-top": "5px"
                })
				switcherLang.css({
					'position': 'static',
					'align-self': 'center'
				});
                switcherLang.find('.wgcurrent.wg-li.wg-flags').css({
                	"display": "flex",
                })
			}, 200)
		}
      
      	function moveLangOld() {
			setTimeout(function() {
				let switcherLang = $('.weglot-container.wg-default aside');
              	console.log(switcherLang);
				let switcherMove = $('.mb-area.header-bottom-left.horizontal-menu');
				let switcherLangCombo = switcherLang.find('form .tl-select');
				let switcherLangOptions = switcherLang.find('form .tl-options');
				let desktopPosition = $('.col-12.col-xl-4.wrapper.header-items .append-mb.right-append');
				if (window.matchMedia('(max-width: 768px)').matches) {
					switcherMove.append(switcherLang);
					switcherLang.css({
						'position': 'static',
						'box-shadow': 'none',
						'border-radius': '3px',
                      	'width': '100%',
                        'margin-left': '10px',
                      'margin-top': '20px'
					});
				

					switcherLangCombo.css({
						'box-shadow': '0 0 10px #00000026',
						'margin-top': '5px',
						'border-radius': '3px',
					})
					switcherLangOptions.css({
						'min-width': '73.13px',
						'left': 'auto',
                      	'top': '103%',
					})
				} else {
					desktopPosition.append(switcherLang);
                  	switcherLang.css('margin-left', '55px');
				}
				switcherLang.css({
					'position': 'static',
					'align-self': 'center'
				});
				switcherLangOptions.css({
					'min-width': '81.7px',
					'left': 'auto'
				})
			}, 2000)
		}

		function moveCurrency() {
			setTimeout(function() {
				let currency = $(".doubly-wrapper");
				let footerBottom = $(".footer-bottom .container");
				currency.css({
					"float": "none"
				})
				currency.find('.layered-currency-switcher').css({
					"float": "none"
				})
				footerBottom.find('address').css({
					"clear": "both",
				});
				footerBottom.append(currency);
				footerBottom.append($("<div style='clear:both' ></div>"));
			}, 2000);
			// 			$('.doubly-wrapper').css({
			// 				'position': 'fixed',
			// 				'right': '10px',
			// 				'bottom': '95px',
			// 			})
		}

		setTimeout(function() {
			function modifyChat() {
				chatButton = $('iframe#dummy-chat-button-iframe');
				$(chatButton).css({
					'right': '8px',
					"width": "200px"
				});

				$(chatButton.contents().find('#dummy-chat-button').css({
					"height": "auto",
					"padding": "10px 20px",
					"max-width": "200px",
					"width": "100%",
					"margin-right": "0",
					"margin-left": "0",
					"display": "block"

				}));
				$(chatButton).contents().find('.chat-title').css({
					"max-width": "100%",
				})
			};


			modifyChat();
		}, 4000)

		function disableSearchPlaceholder() {
			$(".input-group-field.header-search__input").removeAttr('placeholder');
		}

		function relayoutHeader() {
			let rightside = $('.header-panel-bt .container .row').children();
// 			$(rightside[0]).removeClass('wrapper-left col-xl-5').addClass('wrapper col-xl-1');
			$(rightside[1]).removeClass('wrapper-left col-xl-4').addClass('wrapper col-xl-5').css('padding-right','30px');
          	$(rightside[0]).find('.input-group-field.header-search__input').remove();
          	$(rightside[1]).css({
              "display": "flex",
              "justify-content": "end"
            });
			$(rightside[0]).remove();          
          	$(rightside[1]).prepend($(rightside[0]).find('.nav-search').css('margin-right', '36px'));
		}

		function addAnnouncement() {
			setTimeout(function() {
				if (window.matchMedia('(min-width: 1000px)').matches) {
					let positionAnnounce = $('.header-panel-bt .container');
					let myRow = $('<div class="row"></div>');
					let column = $('<div class="col-12"></div>');
					positionAnnounce.append(myRow.append(column.html($('#qab_container'))));
					$('#qab_container #qab_background #qab_bar').css('padding-top', '0');
				} else {
					let mobilePosition = $('.wrapper-header-bt .container');
					let mobileAnnounce = $('#qab_container');
					mobileAnnounce.find('#qab_bar').css('padding-top', '0');
					mobilePosition.append(mobileAnnounce);
				}
			}, 2000);
		};
      
      function arrowSliderBanner(){
        setTimeout(function(){
                  const rightArrow = '<button type="button" class="slick-next slick-arrow" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>';
        const leftArrow = '<button type="button" class="slick-prev slick-arrow" style="display: block;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>';
        const arrowCombine = rightArrow + leftArrow;
        const addDestination = $('.slideshow.slick-initialized.slick-slider.slick-dotted');
        if(!$('#shopify-section-1540952363851').find('.slideshow.slick-initialized.slick-slider.slick-dotted .slick-arrow')[0]){
			addDestination.append(arrowCombine);
        }
        }, 2000)
      }
      
      function cartMenuLink(){
      	let cartLink = $('.header-items.header-cart a');
        cartLink.attr('href', 'https://ninadescriquets.com/cart');
      }

      function changeMobileSearch(){
        let searchMobile = $(".search-mb.svg-mb a.icon-search");
        searchMobile.removeAttr('data-search-mobile-toggle')
        searchMobile.attr('href', 'https://ninadescriquets.com/search?type=product&q=');
      }
      
//       function cartModify(){
//       	    {% if cart.item_count == 0 %}
//     			$('# shopify-section-template--14886223904932__16553461038e57a4b9').css('display', 'none');
//             {% else %}
//                 $('# shopify-section-template--14886223904932__16553461038e57a4b9').css('display', 'block');
//             {% endif %}
//       }




		// moveGiftcard();
		// moveCurrency();
			// disableSearchPlaceholder();
			// moveLang();
		// relayoutHeader();
			// addAnnouncement();
      		// arrowSliderBanner();
      	// cartMenuLink();
//         cartModify();
        	changeMobileSearch();

	});
})